import { Suspense } from 'react'
import { DocumentsForm } from './documents-form'
import { Box, Skeleton, Stack, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useReadDocumentRequest } from '@/api/accounting-dealer'
import { ErrorOutline } from '@mui/icons-material'
import { formatDate } from '@/helpers'
import { PageHeader } from '@/components'
import { routes } from '@/router'

export function MonthlyDocumentsUploadPage() {
  const { document_request_key } = useParams()

  const {
    data: document_request,
    error,
    isLoading: isDocumentRequestLoading,
  } = useReadDocumentRequest(document_request_key!)

  if (isDocumentRequestLoading) {
    return <Loading />
  }

  if (error || !document_request) {
    return (
      <Box textAlign="center">
        <ErrorOutline color="error" fontSize="large" />
        <Typography color="gray">
          Não foi possível carregar o movimento mensal.
        </Typography>
      </Box>
    )
  }

  return (
    <Suspense fallback={<Loading />}>
      <PageHeader rollbackRoute={routes.accounting.monthlyDocuments}>
        Enviar documentos
      </PageHeader>
      <Box sx={{ px: { xs: 0, md: 2 } }}>
        <Typography variant="h5" textAlign="center" mb={4}>
          Referente ao mês de{' '}
          {formatDate(
            `${document_request.year}-${document_request.month}-05`,
            'MMMM/yyyy',
          )}
        </Typography>
        <DocumentsForm documentRequest={document_request} />
      </Box>
    </Suspense>
  )
}

const Loading = () => {
  return (
    <>
      <Skeleton width={280} sx={{ fontSize: 32, mb: 2, mx: 'auto' }} />

      <Stack spacing={3}>
        <Box>
          <Skeleton width={250} sx={{ fontSize: 26, mb: 1 }} />

          <Stack spacing={2}>
            <Box>
              <Skeleton width="80%" />
              <Skeleton variant="rounded" height={60} />
            </Box>
            <Box>
              <Skeleton width="80%" />
              <Skeleton variant="rounded" height={60} />
            </Box>
          </Stack>
        </Box>

        <Box>
          <Skeleton width={250} sx={{ fontSize: 28, mb: 1 }} />

          <Stack spacing={2}>
            <Box>
              <Skeleton width="80%" />
              <Skeleton variant="rounded" height={60} />
            </Box>
          </Stack>
        </Box>
      </Stack>
    </>
  )
}
